import { render, staticRenderFns } from "./instAmountSelector.vue?vue&type=template&id=0a4096bd&scoped=true"
import script from "./instAmountSelector.vue?vue&type=script&lang=js"
export * from "./instAmountSelector.vue?vue&type=script&lang=js"
import style0 from "./instAmountSelector.vue?vue&type=style&index=0&id=0a4096bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4096bd",
  null
  
)

export default component.exports